<template>
    <div class="interactive-map">
        <div class="filters-and-list">
            <div class="qhs-filters">
                <location-filters></location-filters>
            </div>
            <div class="locations">
                <location v-for="location in locations" :key="location.id" :location="location" />
            </div>
        </div>
        <div class="map">
            <div id="map" style="width: 100%; height: 100%;"></div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import {Loader} from '@googlemaps/js-api-loader';
import LocationFilters from './LocationFilters.vue';
import Location from './Location.vue';

/* global google */
export default {
    components: {LocationFilters, Location},

    props: {
        help: {type: Object, required: true},
    },

    data() {
        return {
            show: 'map',
            map: null,
            markers: [],
            visibleMarkers: [],
            activeInfowindow: null,
        };
    },

    computed: {
        ...mapState(['locations', 'mapCenter']),
    },

    watch: {
        mapCenter() {
            this.map.setCenter(new google.maps.LatLng(this.mapCenter.lat, this.mapCenter.lng));

            const bounds = new google.maps.LatLngBounds();
            this.locations.forEach(location => {
                const marker = this.addToMap(location);
                const loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                bounds.extend(loc);
            });

            this.map.fitBounds(bounds);
            this.map.panToBounds(bounds);
        },
    },

    mounted() {
        window.qhsEvents.$on('locationsLoaded', () => {
            this.renderMap();
        });
    },

    beforeDestroy() {
        window.qhsEvents.$off('locationsLoaded');
    },

    created() {
        this.$store.dispatch('getLocations', this.$route.query);
    },

    methods: {
        toggleMarkers() {
            const ids = this.locations.map(location => location.id);

            this.markers.forEach((marker) => {
                marker.setMap(ids.includes(marker.id) ? this.map : null);
            });
        },

        renderMap() {
            const locations = this.locations.filter(location => location.coordinates);
            const loader = new Loader({
                apiKey: 'AIzaSyDuTVdfz_Y9SQdTb81kx2tH86Sca7q0KKE',
                // apiKey: process.env.MIX_GOOGLE_MAPS_KEY,
                version: 'weekly',
            });
            loader.load().then(() => {
                this.map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 4,
                    center: this.mapCenter,
                });

                const bounds = new google.maps.LatLngBounds();
                locations.forEach(location => {
                    const marker = this.addToMap(location);
                    const loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                    bounds.extend(loc);
                });

                this.map.fitBounds(bounds);
                this.map.panToBounds(bounds);

                window.qhsEvents.$emit('renderedMap');
            });
        },

        addToMap(location) {
            const image = `<img width="100%" src="${location.avatar}" alt="${location.building_name}" />`;
            const heading = location.building_name ? `<h3>${location.building_name}</h3>` : '';
            const address = location.address;
            const formattedAddress =
                address && address.length
                    ? `${this.withLineBreaks(address)}<br />`
                    : '';
            const directionsAddress = address && address.length ? address.toString().replace(/ /g, '+') : '';
            const phone = location.phone ? `${location.phone}` : '';
            const contentString = `
                <div class="location">
                    <div class="image">
                        ${image}
                    </div>
                    <div class="text">
                        ${heading}

                        <p class="address">${formattedAddress}</p>
                        <p class="phone"><a href="tel:${location.phone_clickable}">${phone}</a></p>
                        <div class="directions">
                            <a target="_blank" href="https://www.google.com/maps/dir/?api=1&destination=${directionsAddress}">
                                <i aria-hidden="true" class="fas fa-map-marker"></i>
                                <span>Directions</span>
                            </a>
                        </div>
                    </div>
                </div>`;

            const infowindow = new google.maps.InfoWindow({
                content: contentString,
            });

            const marker = new google.maps.Marker({
                position: location.coordinates,
                map: this.map,
                title: location.building_name,
                id: location.id,
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                if (this.activeInfowindow) {
                    this.activeInfowindow.close();
                }
                this.activeInfowindow = infowindow;

                infowindow.open(this.map, marker);
                this.focusLocation(marker);
            });

            return marker;
        },

        focusLocation(index) {
            const markerPosition = this.markers[index].getPosition();
            this.map.panTo(markerPosition);
            this.focusedLocation = index;
        },

        withLineBreaks(value) {
            return value.join('<br />');
        },

        plural(word, value) {
            if (value === 1) {
                word += 's';
            }

            return word;
        },
    },
};
</script>
